const NAMESPACE = "eSignaturesCapsule";

const KEYS = {
    capsuleTitle: "capsuleTitle",
    resendingText: "resendingText",
    visibilityPermissionText: "visibilityPermissionText",
    legacyEnvelopeTitle: "legacyEnvelopeTitle",
    advancedEnvelopeTitle: "advancedEnvelopeTitle"
};

const MESSAGES = {
    [KEYS.capsuleTitle]: {
        value: "eSignature Statuses",
        comment: "Text for eSig status capsule"
    },
    [KEYS.resendingText]: {
        value: "Resending...",
        comment: "UI block when attempting to resend notifications"
    },
    [KEYS.visibilityPermissionText]: {
        value: "These eSignature requests are not visible to {projectOwnerEmail}",
        comment: "Warning message when eSignature request is not visible to a role"
    },
    [KEYS.legacyEnvelopeTitle]: {
        value: "Classic  eSignatures",
        comment: "Default title for Legacy eSignature table"
    },
    [KEYS.advancedEnvelopeTitle]: {
        value: "eSignature Envelopes",
        comment: "Default title for Advanced Signature table"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
